'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcTimelineItem
* @element ANY
* @description
* # tcTimelineItem
* Displays TrakCare Graphical Timeline Items; previously graph.js
* 
* Current item service hooks:
* - loadServiceFunctions - adds additional scope functions specific to the item type
* - serviceOnDisplay - performs additional item-specific setup on initial rendering
* - addServiceWatches - adds any item-specific watches
* - getDecorateAxis - returns a function that adds item-specific markup to the axes
*    (e.g. item markers and units for graphs)
* - getStyleAxisTicks - returns a function that performs item-specific styling for axis ticks
* - getDrawAxisItemData - returns a function to draw an axis item for this item type
* - getRemoveAxisItem - returns a function to performs item-specific actions whenever
*    an axis item is undrawn
* - serviceOnUpdateAxis - performs any additional item-specific updateAxis logic
* - getOnToggleItemVisibility - returns a function that performs additional item-specific
*    show/hide logic when an axis item's visibility is toggled (e.g. showing/hiding
*    reference ranges for graphs)
* - getGetItemLegendMarkerHtml - returns a function to create html for legend item svg markers
*/
angular.module('tcApp')
.directive('tcTimelineItem', function($window, $timeout, $document, TimelineService) {	
	var timelineItemLink = function(scope, element, attrs, ctrl) {
		$timeout(function() {
			var d3 = $window.window.d3;
			var itemWatchers = {};
			var transitionDuration = scope.viewModel.transitionDuration;

			// set the visible timeFrom/To of the graph and redraw
			var updateAxis = function(timeFrom, timeTo, useTransition) {
				// Recalculate X axis domain (zoom into/scroll to provided times)
				ctrl.updateTimeWindow(timeFrom, timeTo);

				angular.forEach(scope.data.axisGroups, function(axisGroup) {
					var svg = axisGroup.getMainGraphSvg();
					// Prepare SVG transition or use plain svg element
					var updateElement = (useTransition ? svg.transition().duration(transitionDuration) : svg);
				
					// Move X axis
					updateElement.selectAll('g.x.axis')
						.call(axisGroup.callXAxis);
				
					// Redraw data items for axes
					angular.forEach(axisGroup.yAxes, function(axis) {
						if (angular.isDefined(axis)) {
							axisGroup.drawAxisItems(axis, useTransition);
						}
					});
					
					// Redraw relative Time base line
					axisGroup.drawRelativeMarkersBaseTime();
				
					// Update future time rect
					axisGroup.drawFutureTimeRect(updateElement);
				
					axisGroup.drawTimeCursorAndSelection(scope.tcSelectedTime, updateElement);
				
					// Perform any additional actions specific to the item type
					ctrl.callItemService(axisGroup, 'serviceOnUpdateAxis');
				});
			};

			// Called on window resize event
			scope.handleResize = function(useTransition) {
				angular.forEach(scope.data.axisGroups, (function(axisGroup, index) {
					var isEventTimeline = scope.data.profileType === TimelineService.EventTimelineType;
					ctrl.initialiseGraphDimensions(axisGroup, index, isEventTimeline);
					axisGroup.setMainSvgDimensions();
					var axisGroupModel = scope.viewModel.axisGroupModel[index];

					var svg = axisGroup.getMainGraphSvg();
			
					// update static elements with new width and/or height
					svg.selectAll('.scrollable').attr('width', axisGroupModel.dimensions.width);
					svg.selectAll('.graphClipPathRect')
						.attr('width', axisGroupModel.dimensions.width)
						.attr('height', axisGroupModel.dimensions.height);
					svg.selectAll('.timeHeaderContainer').attr('width', axisGroupModel.dimensions.width);
					svg.selectAll('.timeNow').attr('height', axisGroupModel.dimensions.height);
					svg.selectAll('.selectedColumn').attr('height', axisGroupModel.dimensions.height);
					svg.selectAll('.timeCursorLine').attr('y2', axisGroupModel.dimensions.height);
			
					// clear and redraw Y axes
					axisGroup.drawYAxes();
				}));

				// redraw graph
				updateAxis(scope.tcTimeFrom, scope.tcTimeTo, useTransition);
			};
		
			// Returns the html for the svg marker to be displayed in the legend for a given legend item
			// Called as getItemLegendMarkerHtml(item)
			scope.getItemLegendMarkerHtml = ctrl.callItemService(null, 'getGetItemLegendMarkerHtml', function() { return ''; });
		
			// Add additional scope functions specific to the item type
			ctrl.callItemService(null, 'loadServiceFunctions');
		
			/// Initial setup ///
			angular.forEach(scope.data.axisGroups, function(axisGroup, index) {
				// draw new svg elements for X Axis
				// Only called once, on init, after which additional x-axis
				// changes are handled by updateAxis
				var axisGroupModel = scope.viewModel.axisGroupModel[index];
				axisGroup.htmlIdPrefix = scope.getAxisGroupHTMLId(index);

				var margin = axisGroupModel.dimensions.margin; // for use in init ONLY
				var height = axisGroupModel.dimensions.height; // for use in init ONLY

				// elements
				var svg;
				var tooltip;
				var axisContainer;
				var scrollableContainer;

				axisGroup.decorateAxis = ctrl.callItemService(axisGroup, 'getDecorateAxis', function() { return; });
			
				var drawXAxis = function() {
					axisContainer.append('g')
						.attr('class', 'x axis')
						.attr('font-size', '')
						.call(axisGroup.callXAxis);	
				};

				// call xAxis axis function and restyle ticks
				axisGroup.callXAxis = function(g) {
					var xAxis = scope.tcXAxis;
					if (angular.isFunction(xAxis)) {
						// update tickSize to be height of current graph
						xAxis.tickSize(-scope.viewModel.axisGroupModel[index].dimensions.height);
						g.call(xAxis);
						g.selectAll('.tick:not(:first-of-type) line').attr('stroke', '');
					}
				};

				// set dimension properties for main svg element
				axisGroup.setMainSvgDimensions = function() {
					if (angular.isDefined(svg)) {
						var svgWidth = axisGroupModel.dimensions.width
							+ axisGroupModel.dimensions.margin.left
							+ axisGroupModel.dimensions.margin.right;
						var svgHeight = axisGroupModel.dimensions.height
							+ axisGroupModel.dimensions.margin.top
							+ axisGroupModel.dimensions.margin.bottom;
						svg.attr('width', svgWidth)
							.attr('height', svgHeight);
							svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight);
						
					}	
				};
			
				// draw new svg elements for all Y axes
				// called on init and in updateAxis
				axisGroup.drawYAxes = function() {
					var axisSVGGroups = axisContainer
						.selectAll('g.y.axis')
						.data(axisGroup.yAxes, function(d) { return d.axesIndex; });
				
					axisSVGGroups.enter()
						.append('g')
						.each(function(d) {
							var axisSVGGroup = d3.select(this);
							axisSVGGroup.classed('y axis', true)
								.classed('left', ctrl.isLeftAxis(d.axesIndex))
								.classed('right', ctrl.isRightAxis(d.axesIndex));
						})
					.merge(axisSVGGroups)
						.each(function(d) {
							var axisSVGGroup = d3.select(this);
							axisSVGGroup.call(callYAxis, d.axesIndex)
								.call(styleAxisTicks);
						});
					
					axisSVGGroups.exit().remove();
				};
			
				// call yAxis axis functions and restyle ticks
				var callYAxis = function(g, axesIndex) {
					// values that vary from left to right axes
					var axisTranslates = [0, axisGroupModel.dimensions.width];
					var tickTextXValues = [-13, 14];
				
					g.attr('transform', 'translate(' + axisTranslates[axesIndex]  + ', 0)');
					g.call(axisGroupModel.yAxes[axesIndex]);
					g.selectAll('.tick text').attr('x', tickTextXValues[axesIndex]);
					if (ctrl.isLeftAxis(axesIndex)) g.selectAll('.tick line').style('opacity', '0.25');
					g.selectAll('.tick:not(:first-of-type) line').attr('stroke', '');
				};

				// applies item specific styling to y-axis ticks
				// called as styleAxisTicks(axisGroup)
				var styleAxisTicks = ctrl.callItemService(axisGroup, 'getStyleAxisTicks', function() { return; });
		
				// Exposes mainGraph svg element to the item services
				axisGroup.getMainGraphSvg = function() {
					return svg;
				};
		
				// Exposes tooltip element to the various item services
				axisGroup.getTooltip = function() {
					return tooltip;
				};

				// Exposes axisContainer element to the various item services
				axisGroup.getAxisSvgContainer = function() {
					return axisContainer;
				};
		
				// Return container element for all graph Item svg elements
				// Exposes this element to the various item services
				axisGroup.getDataSvgContainer = function() {
					return scrollableContainer;
				};
		
				// Return Id for <g> element that contains svg for the items on a given axis
				var getAxisGroupId = function(axis) {
					return axisGroup.htmlIdPrefix + '-axisGroup_' + axis.axesIndex;
				};
		
				// Return Id for <g> element that contains svg for axis item
				// Can be used by item services
				axisGroup.getAxisItemGroupId = function(axisDataItem) {
					return this.htmlIdPrefix + '-itemGroup_' + axisDataItem.htmlId;
				};
		
				// draw all svg elements for all items on an axis
				// should be called whenever data is updated or time from/to changes
				axisGroup.drawAxisItems = function(axis, useTransition) {
					var transition = (useTransition ? d3.transition().duration(transitionDuration) : d3.transition().duration(0));
					
					var axisSVGGroup = TimelineService.getOrCreateSvgElementById(getAxisGroupId(axis), 'g', scrollableContainer);
					var itemGroups = axisSVGGroup.selectAll('g.itemGroup')
						.data(axis.items, function(item) {return item.htmlId;});
					
					itemGroups.enter()
						.append('g')
						.classed('itemGroup', true)
						.attr('id', function(item) {return axisGroup.getAxisItemGroupId(item);})
					.merge(itemGroups)
						.each(function(item) {
							var itemGroup = d3.select(this);
							
							drawAxisItemData(axis, axisSVGGroup, item, itemGroup, transition);
						});
					
					itemGroups.exit()
						.each(function(item) {
							// perform any actions specific to the timeline item type when an item is being undrawn
							var itemGroup = d3.select(this);
							
							removeAxisItem(item, itemGroup);
						})
						.remove();
				};
		
				// draws the data for a particular axis item
				// called as drawAxisItemData(axis, axisGroup, item, itemGroup, transition)
				var drawAxisItemData = ctrl.callItemService(axisGroup, 'getDrawAxisItemData', function() { return; });
		
				// performs any necessary actions when an axis item is undrawn
				// called as removeAxisItem(item, itemGroup)
				var removeAxisItem = ctrl.callItemService(axisGroup, 'getRemoveAxisItem', function() { return; });
		
				// Draw line for relative markers staring time, matching parent time header
				axisGroup.drawRelativeMarkersBaseTime = function() {
					if (angular.isNumber(scope.tcRelativeMarkersBaseTime)) {
						var lineElement = TimelineService.getOrCreateSvgElementById('relativeTimeMarkerLine', 'line',
																					scrollableContainer);
						// Add 0.5 to xCoordinate to match axis tick from timeline parent
						var xCoordinate = ctrl.getXCoordinateFromTime(scope.tcRelativeMarkersBaseTime) + 0.5;
						lineElement.classed('relativeTimeLine', true)
							.attr('x1', xCoordinate)
							.attr('y1', 0)
							.attr('x2', xCoordinate)
							.attr('y2', axisGroupModel.dimensions.height);
					}
				};
		
				// resizes future time rect based on portion of visible window that is in the future
				axisGroup.drawFutureTimeRect = function(updateElement) {
					var timeNow = scope.tcTimeNow;
					var timeNowCoordinate = ctrl.getXCoordinateFromTime(timeNow);
					var futureTimeRect = updateElement.selectAll('rect.timeNow');
					if (timeNow > scope.tcTimeTo) { // entire window is in the past, hide rect
						futureTimeRect.attr('width', 0);
					} else if (timeNow < scope.tcTimeFrom) { // entire window is in the future, only show shading rect
						futureTimeRect.attr('width', axisGroupModel.dimensions.width)
							.attr('x', 0);
					} else { // timeNow marker is within visible window, update position rect
						var timeNowDiff = axisGroupModel.dimensions.width - timeNowCoordinate;
						var rectWidth = (timeNowDiff >= 0 ? timeNowDiff : 0);
						futureTimeRect.attr('width', rectWidth)
							.attr('x', timeNowCoordinate);
					}
				};
		
				// Given a selected time, places the time cursor line at that time, and highlights the column containing that interval
				axisGroup.drawTimeCursorAndSelection = function(selectedTime, updateElement) {
					var timeCursor = updateElement.selectAll('line.timeCursorLine');
					var selectedColumn = updateElement.selectAll('rect.selectedColumn');
				
					if (selectedTime == null) {
						timeCursor.attr('opacity', 0);
					
						selectedColumn.attr('opacity', 0);
					
						return;
					}
				
					var selectedPosition = ctrl.getXCoordinateFromTime(selectedTime);
					var selectionTicks = TimelineService.getColumnTimes(selectedTime, scope.tcTimeInterval);
					var x1coord = ctrl.getXCoordinateFromTime(selectionTicks[0]);
					var x2coord = ctrl.getXCoordinateFromTime(selectionTicks[1]);
					var intervalWidth = x2coord - x1coord - 1;
				
					timeCursor
						.attr('x1', selectedPosition)
						.attr('x2', selectedPosition)
						.attr('opacity', 1);
				
					selectedColumn
						.attr('width', intervalWidth)
						.attr('x', x1coord + 1)
						.attr('opacity', 1);
				};

				// Hide/show graph items when label checkbox is clicked
				axisGroup.toggleItemVisibility = function(item, noTransition) {
					var useTransition = !noTransition;
					axisGroup.toggleSvgGroupById(axisGroup.getAxisItemGroupId(item), item.visible, useTransition);
					
					onToggleItemVisibility(item);
				};
			
				// Performs any additional logic to show/hide information relevant to an item
				// called as onToggleItemVisibility(item)
				var onToggleItemVisibility = ctrl.callItemService(axisGroup, 'getOnToggleItemVisibility', function() { return; });
			
				// Given the id of an svg element (typically a g),
				// sets its visibility according to show, using
				// a transition if useTransition is true
				axisGroup.toggleSvgGroupById = function(Id, show, useTransition) {
					var group = svg.select('#' + Id);
					var showHideDuration = (useTransition ? transitionDuration : 0);
					if (!group.empty()) {
						if (show) {
							group.transition()
								.duration(showHideDuration)
								.style('pointer-events', 'all')
								.style('opacity', 1);
						} else {
							group.transition()
								.duration(showHideDuration)
								.style('pointer-events', 'none')
								.style('opacity', 0);
						}
					}
				};
				
				svg = d3.select(element[0]).select('#' + scope.getMainGraphSVGId(index));
				axisGroup.setMainSvgDimensions();
				// Define the div for the tooltip
				tooltip = d3.select(element[0]).select('#' + scope.getTooltipId(index)).append('div')
					.attr('class', 'tooltip')
					.style('opacity', 0);
				axisContainer = svg.append('g')
					.attr('transform', 'translate('
						+ margin.left + ','
						+ margin.top + ')');
			
				// Graph title to axis to show when legend is collapsed
				// x and y value are based on position after rotation
				// If timeline has only a single row, allow title to extend
				// into the top and bottom margins for increased readability
				var titleX = -(height + (axisGroup.steps === 1 ? margin.bottom : 0));
				var titleY = -(margin.left + 2);
				var titleWidth = height + (axisGroup.steps === 1 ? margin.bottom + margin.top : 0);
				var titleHeight = margin.left;
				axisContainer.append('foreignObject')
					.classed('graphTitle', true)
					.attr('y', titleY)
					.attr('x', titleX)
					.attr('width', titleWidth)
					.attr('height', titleHeight)
					.attr('transform', 'rotate(270)')
					.attr('visibility', (scope.tcShowLegend ? 'hidden' : 'visible'))
					.append('xhtml:div')
					.text(axisGroup.legendCaption);
					
				axisGroup.decorateAxis(axisContainer);

				drawXAxis();
				axisGroup.drawYAxes();
			
				var dataClipPathId = scope.htmlIdPrefix + '-dataClipPath';
				axisContainer.append('clipPath')
					.attr('id', dataClipPathId)
					.append('rect')
					.classed('graphClipPathRect', true)
					.attr('x', 0)
					.attr('y', 0)
					.attr('width', axisGroupModel.dimensions.width)
					.attr('height', height);
					
				var clipPath = axisContainer.append('g')
					.attr('clip-path', 'url(#' + dataClipPathId + ')');
				
				// scrollableContainer will hold all data svg elements
				scrollableContainer = clipPath.append('g')
					.attr('width', axisGroupModel.dimensions.width)
					.classed('scrollable', true);
				scrollableContainer.append('g')
					.attr('transform', 'translate(0,0)');
					
				scrollableContainer.append('rect')
					.classed('selectedColumn', true)
					.attr('x', 0)
					.attr('y', 1)
					.attr('height', height - 1);
					
				// Add timeNow Rect
				scrollableContainer.append('rect')
					.classed('timeNow', true)
					.attr('x', 0)
					.attr('y', 1)
					.attr('height', height - 1);
					
				scrollableContainer.append('line')
					.classed('timeCursorLine', true)
					.attr('y1', 1)
					.attr('y2', height);
			
				// Perform additional setup specific to the item type
				ctrl.callItemService(axisGroup, 'serviceOnDisplay');

			});
		
			/// Watches and listeners ///
			// Watch for changes to timeFrom/To and viewModel.showLabels,
			// updating the axes or resizing (as appropriate) if any have changed
			scope.$watchGroup(['tcTimeFrom','tcTimeTo','viewModel.showLabels'], function(newValues, oldValues) {
				// Use transition if interval has changed
				var useTransition = scope.viewModel.lastInterval !== scope.tcTimeInterval; 
				var resize = (newValues[2] !== oldValues[2]);
				if (!resize) {
					angular.forEach(scope.data.axisGroups, function(axisGroup, index) {
						if (axisGroup.steps !== scope.viewModel.axisGroupModel[index].steps) {
							scope.viewModel.axisGroupModel[index].steps = axisGroup.steps;
							resize = true;
						}
					});
				}
				if (resize) {
					scope.handleResize(useTransition);
				} else {
					updateAxis(newValues[0], newValues[1], useTransition);
				}
				scope.viewModel.lastInterval = scope.tcTimeInterval;
			});
		
			// Update axis caption/units display on change of tcShowLegend
			scope.$watch('tcShowLegend', function(newValue, oldValue) {
				if (newValue !== oldValue) {
					angular.forEach(scope.data.axisGroups, function(axisGroup) {
						var svg = axisGroup.getMainGraphSvg();
						svg.selectAll('.graphTitle')
							.attr('visibility', (newValue ? 'hidden' : 'visible'));
						axisGroup.decorateAxis(axisGroup.getAxisSvgContainer());
					});
				}
			});

			// Re-decorate axis units every time a graph is uncollapsed
			scope.$watch('data.collapsed', function(newValue, oldValue) {
				if (newValue !== oldValue && newValue === false) {
					// Timeout needed to guarantee that re-decorate executes after the element is shown on the page
					$timeout(function() {
						angular.forEach(scope.data.axisGroups, function(axisGroup) {
							axisGroup.decorateAxis(axisGroup.getAxisSvgContainer());
						});
					});
				}
			});

			// Resize display when graph width is updated from parent on resize or legendToggle
			scope.$watch('tcGraphWidth', function(newValue, oldValue) {
				if (newValue !== oldValue) {
					scope.handleResize();
					angular.forEach(scope.data.axisGroups, function(axisGroup) {
						axisGroup.decorateAxis(axisGroup.getAxisSvgContainer());
					});
				}
			});
		
			// Redraw time cursor/selection when selected time changes
			scope.$watch('tcSelectedTime', function(newValue, oldValue) {
				if (newValue !== oldValue) {
					angular.forEach(scope.data.axisGroups, function(axisGroup) {
						axisGroup.drawTimeCursorAndSelection(newValue, axisGroup.getMainGraphSvg());
					});
				}
			});

			// for event timelines, whenever there is new data relink the items to their event categories
			if (scope.data.profileType === TimelineService.EventTimelineType) {
				// event timelines have only one axisGroup with one yAxis, which contains all of the event items
				scope.$watch('data.axisGroups[0].yAxes[0].items', function(newValue, oldValue) {
					if (newValue !== oldValue) {
						var axisGroup = scope.data.axisGroups[0];

						// because item.visible watchers are created using item indices up to the number of items on load,
						// if the number of event items increases there won't be any watchers for some of the trailing event items.
						// to remedy this recreate the item.visible watchers using the current/correct number of item indices
						angular.forEach(axisGroup.yAxes[0].items, function(item, itemIndex) {
							// unbind old watchers so that extra watchers aren't created on data reload
							if (itemWatchers['itemWatcher0_0_'+itemIndex]) {
								itemWatchers['itemWatcher0_0_'+itemIndex]();
							}
							var visibleWatchExpr = 'data.axisGroups[0].yAxes[0].items[' + itemIndex + '].visible';
							itemWatchers['itemWatcher0_0_'+itemIndex] = scope.$watch(visibleWatchExpr, function() {
								item = scope.data.axisGroups[0].yAxes[0].items[itemIndex];
								if (item) axisGroup.toggleItemVisibility(item);
							});
						});
					}
					scope.linkLegendCategoriesToItems();
				});
			}
		
			// watch item.visible for each item of each axis
			angular.forEach(scope.data.axisGroups, function(axisGroup, axisGroupIndex) {
				angular.forEach(axisGroup.yAxes, function(axis, axisIndex) {
					angular.forEach(axis.items, function(item, itemIndex) {
						var visibleWatchExpr = 'data.axisGroups[' + axisGroupIndex + '].yAxes['
												+ axisIndex + '].items[' + itemIndex + '].visible';
						itemWatchers['itemWatcher'+axisGroupIndex+'_'+axisIndex+'_'+itemIndex] = 
												scope.$watch(visibleWatchExpr, function() {
							// reset item in case new data has been bound in from a parent scope
							item = scope.data.axisGroups[axisGroupIndex].yAxes[axisIndex].items[itemIndex];
							if (item) axisGroup.toggleItemVisibility(item);
						});
					});
				});
			});
		
			// Add additional watches specific to the item type
			angular.forEach(scope.data.axisGroups, function(axisGroup) {
				ctrl.callItemService(axisGroup, 'addServiceWatches');
			});
		});
		
		
		// redraw on document ready to avoid misalignment between timelineTimeHeaderSVG and the timeline mainGraph that happens when the scrollbar is present.
		$document.ready(function() {
			scope.handleResize();
			angular.forEach(scope.data.axisGroups, function(axisGroup) {
				axisGroup.decorateAxis(axisGroup.getAxisSvgContainer());
			});
		});
	};

	return {
			restrict: 'E',
			templateUrl: 'template/timelineItem/timelineItem.html',
			scope: {
				data: '=?',
				htmlIdPrefix: '@id',
				tcTimeFrom: '=?',
				tcTimeTo: '=?',
				tcTimeInterval: '=?',
				tcTimeDirection: '=?',
				tcShowLegend: '=?',
				tcRelativeMarkersBaseTime: '=?',
				tcGraphWidth: '=?',
				tcTimeNow: '=?',
				tcTranslations: '=?',
				tcXScale: '=?',
				tcXAxis: '=?',
				tcRefRangeBaseTime: '=?',
				tcSelectedTime: '=?'
			},
			controller: 'TimelineItemCtrl',
			link: timelineItemLink
		};
});
